import { useContext, useMemo } from 'react';
import { AppContext } from 'views/App/context';

export default function useHasAccreditationSolution(organizationId?: string): boolean {
  const { hasPermission, currentOrganizationId } = useContext(AppContext);
  const orgId = organizationId ?? currentOrganizationId ?? '';
  return useMemo(
    () =>
      hasPermission('awbEssentials', orgId) || hasPermission('awbPremium', orgId),
    [hasPermission, orgId]
  );
}
